import http from "infra/http";
import { useMutation } from "react-query";
import {FeriadoResponsePaginate} from "../typings"
import FeriadosEvents from "../events";

export default function useSaveFeriados(tenantId?: string) {
  return useMutation(async (body: FeriadoResponsePaginate) => {
    const headers = { tenant: tenantId ?? null };

    if (body.id) {
      FeriadosEvents.atualizar(body.id);

      const { data } = await http.put(`/v1/feriado/${body.id}`, body, {
        headers,
      });

      return data;
    }

    FeriadosEvents.criar();

    const { data } = await http.post("/v1/feriado", body, { headers });

    return data;
  });
}
